<template>
  <div class="simplify__nav">
    <section
      class="stickyPanel"
    >
      <slot name="buttons" />
    </section>
  </div>
</template>

<style>

.c-sticky {
  @apply fixed flex bottom-0 left-0 w-screen h-10;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  z-index: 12; /* Between 11 (offers tile checkbox) and 15 (Ampersend SDK) */


  .c-btn--mobile {
    @apply h-10;
    flex: 1;
    border-radius: 0;
  }

  .c-btn--secondary, .c-btn--secondary--mobile {
    @apply h-10;
    border: none;
  }
}

.nav-buttons {
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-bottom: 40px;
}

.simplify__nav-button {
  width: 100%;
  min-width: 0px;
}

</style>

<script>

export default {
  name: 'StickyPanel',

  mounted() {
    const heroButton = document.querySelector('.simplify__nav');

    const moveBtn = (e) => {
      const navBtn = document.querySelector('.stickyPanel');
      if (!e[0].isIntersecting && navBtn !== null) {
        navBtn.classList.remove('nav-buttons');
        navBtn.classList.add('c-sticky');
      }
      if (e[0].isIntersecting && navBtn !== null) {
        navBtn.classList.remove('c-sticky');
        navBtn.classList.add('nav-buttons');
      }
    };

    const moveBtnIntersectionObs = new IntersectionObserver(moveBtn);
    moveBtnIntersectionObs.observe(heroButton);
  },
};
</script>
